import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from '../styles/Navbar.module.css';

const Navbar: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  
  // Close menu when route changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);
  
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (menuOpen && !target.closest(`.${styles.navbar}`)) {
        setMenuOpen(false);
      }
    };
    
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [menuOpen]);
  
  // Check if the current path matches the link path
  const isActive = (path: string) => {
    return location.pathname === path;
  };

  // Toggle menu state
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={styles.navbar}>
      <div className={styles.navbarContainer}>
        <Link to="/" className={styles.navbarLogo}>
          $BAKSO
        </Link>
        
        <button 
          className={styles.menuButton} 
          onClick={toggleMenu} 
          aria-label="Toggle navigation menu"
          aria-expanded={menuOpen}
        >
          <span className={`${styles.menuIcon} ${menuOpen ? styles.menuIconOpen : ''}`}>
            <span className={styles.menuBar}></span>
            <span className={styles.menuBar}></span>
            <span className={styles.menuBar}></span>
          </span>
        </button>
        
        <div className={`${styles.navMenuWrapper} ${menuOpen ? styles.active : ''}`}>
          <ul className={styles.navMenu}>
            <li className={styles.navItem}>
              <Link 
                to="/" 
                className={isActive('/') ? styles.navLinkActive : styles.navLink}
              >
                Home
              </Link>
            </li>
             {/*<li className={styles.navItem}>
              <Link 
                to="/baksoai" 
                className={isActive('/baksoai') ? styles.navLinkActive : styles.navLink}
              >
                BaksoAI
              </Link>
            </li>*/}
            <li className={styles.navItem}>
              <Link 
                to="/swap" 
                className={isActive('/swap') ? styles.navLinkActive : styles.navLink}
              >
                Swap
              </Link>
            </li>
            {/*<li className={styles.navItem}>
              <Link 
                to="/roarmap" 
                className={isActive('/roarmap') ? styles.navLinkActive : styles.navLink}
              >
                RoarMap
              </Link>
            </li>*/}
            <li className={styles.navItem}>
              <Link 
                to="/gallery" 
                className={isActive('/gallery') ? styles.navLinkActive : styles.navLink}
              >
                Gallery
              </Link>
            </li>
            {/*<li className={styles.navItem}>
              <Link 
                to="/conservation" 
                className={isActive('/conservation') ? styles.navLinkActive : styles.navLink}
              >
                BCF
              </Link>
            </li>*/}
            <li className={styles.navItem}>
              <Link 
                to="/games" 
                className={isActive('/games') ? styles.navLinkActive : styles.navLink}
              >
                Games
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;